import axios from 'axios';
import swal from 'sweetalert2';// import sweet alert

const state = {
    uploadProgress: null,
    accessToken: localStorage.getItem('applicantId') || null,
};

const getters = { 

};

const actions = {
    async getAssessmentTypes(state, data) {// get user Appointments
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getAssessmentTypesUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async getAssessmentBatch(state, data) {// get user Appointments
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getAssessmentBatchUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async getAssessmentPayment(state, data) {// get user Appointments
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getAssessmentPaymentUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async generateAssessmentRrr(state, data) {// get user Appointments
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.generateAssessmentRrrUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async getAssRemitaPaymentDetails(state, id) {// get user Appointments
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getAssRemitaPaymentDetailsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, { 'id' : id }, { headers: header});// make api call
        return response.data;
    },
    async getAssessmentRrrStatus(state, data) {// get user Appointments
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getAssessmentRrrStatusUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async getApplicantInfo(state, id) {// get user Appointments
        const url = state.rootState.url.getApplicantInfoUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, { id : id }, { headers: header});// make api call
        return response.data;
    },
    async saveAssessmentApplicantData(state, data) {// get user Appointments
        const url = state.rootState.url.saveAssessmentApplicantDataUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async uploadAssessmentPhoto(state, data) {// get user Appointments
        const url = state.rootState.url.uploadAssessmentPhotoUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async deleteAssessmentEduRecord(state, id) {// get user Appointments
        const url = state.rootState.url.deleteAssessmentEduRecordUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, { cId : id }, { headers: header});// make api call
        return response.data;
    },
    async deleteAssessmentQualification(state, id) {// get user Appointments
        const url = state.rootState.url.deleteAssessmentQualificationUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, { cId : id }, { headers: header});// make api call
        return response.data;
    },
    async deleteAssessmentEmployment(state, id) {// get user Appointments
        const url = state.rootState.url.deleteAssessmentEmploymentUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, { cId : id }, { headers: header});// make api call
        return response.data;
    },
    async deleteAssessmentExamination(state, id) {// get user Appointments
        const url = state.rootState.url.deleteAssessmentExaminationUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, { cId : id }, { headers: header});// make api call
        return response.data;
    },
    async deleteAssessmentInstitution(state, id) {// get user Appointments
        const url = state.rootState.url.deleteAssessmentInstitutionUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, { cId : id }, { headers: header});// make api call
        return response.data;
    },
    async deleteAssessmentReferee(state, id) {// get user Appointments
        const url = state.rootState.url.deleteAssessmentRefereeUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, { cId : id }, { headers: header});// make api call
        return response.data;
    },
    async submitAssessmentForm(state, id) {// get user Appointments
        const url = state.rootState.url.submitAssessmentFormUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, { 'id' : id }, { headers: header});// make api call
        return response.data;
    },
    async addExtraAssessmentCharge(state, data) {// get user Appointments
        const url = state.rootState.url.addExtraAssessmentChargeUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async getAssessmentInstitutions(state, data) {// get user Appointments
        const url = state.rootState.url.getAssessmentInstitutionsUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async uploadAssessmentDocuments(state, data) {// get user Appointments
        const url = state.rootState.url.uploadAssessmentDocumentsUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, data, {
            headers: header,
            onUploadProgress: uploadEvent => {
                state.state.uploadProgress = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
            }
        });// make api call
        return response.data;
    },
    async addAdditionalAssessmentRrr(state, data) {// get user Appointments
        const url = state.rootState.url.addAdditionalAssessmentRrrUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async viewAssessmentDocument(state, filename) {// fetch user document function
        const url = state.rootState.url.assessmentDocumentViewUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        try {
            const response = await axios.post(url, 
                        { 
                            filename: filename
                        },
                        { 
                            responseType: 'blob', 
                            headers: header 
                        });// make api call
            const blobUrl = URL.createObjectURL(
            new Blob([response.data], { type: 'application/pdf' })
            );

            window.open(blobUrl, '_blank');
            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
            return blobUrl;
        } catch (error) {
            swal.fire("Error!", "Unable to view document", "error");
        }
    },
    async printExamCard(state, id) {
        // const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.printAssessmentCardUrl;
        const header = {'X-Assessment-Token': state.state.accessToken};
        try {
            const response = await axios.post(url,
            {
                id: id
            },
            {
                responseType: 'blob',
                headers: header,
            }
            );
            const fileUrl = URL.createObjectURL(
            new Blob([response.data], { type: 'application/pdf' })
            );
            window.open(fileUrl, '_blank');
        } catch (error) {
            swal.fire("Error!", "Failed to print exam card:," + error, "error");
        }
    }
};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}